/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=c862dc0e"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/disney-back-ui-production-environment/lqdsn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__